// if ( typeof CartForm !== 'function' ) {
// 	class CartForm extends HTMLElement {

// 		constructor(){
// 			super();
// 			this.ajaxifyCartItems();
// 		}

// 		ajaxifyCartItems(){

// 			this.form = this.querySelector('form');
// 			const prefix = window.KT_PREFIX || '';

// 			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

// 				const remove = item.querySelector(`.${prefix}remove`);
// 				if ( remove ) {
// 					remove.dataset.href = remove.getAttribute('href');
// 					remove.setAttribute('href', '');
// 					remove.addEventListener('click', (e)=>{
// 						e.preventDefault();
// 						this.updateCartQty(item, 0);
// 					})
// 				}

// 				const qty = item.querySelector(`.${prefix}qty`);
// 				if ( qty ) {
// 					qty.addEventListener('input', debounce(e=>{
// 						e.preventDefault();
// 						e.target.blur();
// 						this.updateCartQty(item, parseInt(qty.value));
// 					}, 500));
// 					qty.addEventListener('click', (e)=>{
// 						e.target.select();
// 					})
// 				}

// 			})

// 		}

// 		updateCartQty(item, newQty){

// 			let alert = null;
// 			const prefix = window.KT_PREFIX || '';

// 			this.form.classList.add(`${prefix}processing`);
// 			if ( this.querySelector(`.${prefix}alert`) ) {
// 				this.querySelector(`.${prefix}alert`).remove();
// 			}

// 			const body = JSON.stringify({
// 				line: parseInt(item.dataset.line),
// 				quantity: newQty
// 			});

// 			fetch(KROWN.settings.routes.cart_change_url, {
// 					method: 'POST',
// 					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
// 					body
// 				})
// 				.then(response => response.json())
// 				.then(response => {
// 					if ( response.status == 422 ) {
// 						// wrong stock logic alert
// 						alert = document.createElement('span');
// 						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
// 						if ( typeof response.description === 'string' ) {
// 							alert.innerHTML = response.description;
// 						} else {
// 							alert.innerHTML = response.message;
// 						}
// 						KROWN.functions.eventDispatcher('krown:cart:error', {
// 							error: alert.textContent
// 						});
// 					}
// 					return fetch('?section_id=helper-cart');
// 				})
// 				.then(response => response.text())
// 				.then(text => {

// 					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
// 					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
// 					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

// 					const cartItems = document.getElementById('AjaxCartForm');
// 					cartItems.innerHTML = cartFormInnerHTML;
// 					cartItems.ajaxifyCartItems();

// 					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
// 						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
// 					});
// 					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
// 						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
// 					});

// 					if ( alert !== null ) {
// 						this.form.prepend(alert);
// 					} 

// 					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
// 					const event = new Event('cart-updated');
// 					this.dispatchEvent(event);

// 					const updatedItem = cartItems.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
// 					if ( updatedItem ) {
// 						KROWN.functions.eventDispatcher('krown:cart:update', {
// 							itemKey: updatedItem.dataset.id,
// 							itemQty: updatedItem.dataset.qty,
// 							itemVariantId: updatedItem.dataset.variant,
// 							itemProductId: updatedItem.dataset.productId
// 						});
// 					}

// 				})
// 				.catch(e => {
// 					console.log(e);
// 					let alert = document.createElement('span');
// 					alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
// 					alert.textContent = KROWN.settings.locales.cart_general_error;
// 					this.form.prepend(alert);
// 				})
// 				.finally(() => {
// 					this.form.classList.remove(`${prefix}processing`);
// 				});
// 		}

// 	} 


//   if ( typeof customElements.get('cart-form') == 'undefined' ) {
// 		customElements.define('cart-form', CartForm);
// 	}

// }

// if ( typeof CartProductQuantity !== 'function' ) {

// 	class CartProductQuantity extends HTMLElement {
// 		constructor(){
// 			super();
// 			this._prefix = window.KT_PREFIX || '';
// 			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
// 			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
// 		}
// 		changeCartInput(){
// 			setTimeout(()=>{
// 				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));
// 			}, 50);
// 		}
// 	}

//   if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
// 		customElements.define('cart-product-quantity', CartProductQuantity);
// 	}

// }

// // method for apps to tap into and refresh the cart

// if ( ! window.refreshCart ) {

// 	window.refreshCart = (openDrawer = true) => {
		
// 		fetch('?section_id=helper-cart')
// 			.then(response => response.text())
// 			.then(text => {

// 			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
// 			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
// 			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

// 			const cartItems = document.getElementById('AjaxCartForm');
// 			cartItems.innerHTML = cartFormInnerHTML;
// 			cartItems.ajaxifyCartItems();

// 			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
// 				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
// 			});
// 			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
// 				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
// 			})
			
// 			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
// 			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
// 				document.querySelector('[data-js-site-cart-sidebar]').show();
// 			}

// 			if ( document.querySelector('cart-recommendations') ) {
// 				document.querySelector('cart-recommendations').innerHTML = '';
// 				document.querySelector('cart-recommendations').generateRecommendations();
// 			}

// 		})

// 	}

// }

// if ( ! customElements.get('cart-note') ) {
//   customElements.define(
//     'cart-note',
//     class CartNote extends HTMLElement {
//       constructor() {
//         super();
//         this.addEventListener(
//           'input',
//           debounce(event => {
//             const body = JSON.stringify({ note: event.target.value });
//             fetch(`${KROWN.settings.routes.cart_update_url}`, { 
// 							method: 'POST',
// 							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
// 							body 
// 						});
// 		  		}, 300)
// 				);
//       }
//     }
//   );
// }

// if ( ! customElements.get('cart-discounts' ) ) {
// 	customElements.define(
// 		'cart-discounts',
// 		class CartDiscounts extends HTMLElement {

// 			constructor() {

// 				super();

// 				const button = this.querySelector('[data-js-discount-submit]');
// 				this.input = this.querySelector('[data-js-discount-input]');
// 				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
// 				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
// 				this.discountCodes = document.querySelector('[data-js-discount-codes]');
// 				this._prefix = window.KT_PREFIX || '';
// 				this.loadDiscountButtons();

// 				button.addEventListener('click', (e) => {
// 					e.preventDefault();
// 					if ( this.input.value.length > 0 ) {

// 						this.cartSubtotal.classList.add(`${this._prefix}processing`);
// 						if (this.discountCodes) {
// 							this.discountCodes.classList.add(`${this._prefix}processing`);
// 						}

// 						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
// 						const allDiscounts = [...existingDiscounts, this.input.value];
// 						const discountString = allDiscounts.join(',');
// 						const body = JSON.stringify({ discount: discountString });

// 						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
// 							method: 'POST',
// 							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
// 							body 
// 						})
// 							.then(response => response.json())
// 							.then(response => {
// 								const discountCodes = response.discount_codes;
// 								const inputValue = this.input.value;
// 								const matchingCode = discountCodes.find(code => 
// 									code.code === inputValue
// 								);

// 								if (matchingCode) {
// 									if (matchingCode.applicable) {
// 										this.handleSuccess();
// 									} else {
// 										this.handleError();
// 									}
// 								} else {
// 									this.handleError();
// 								}
// 							})
// 							.catch(error => {
// 								this.handleError();
// 								console.log(`Error: ${error}`);
// 							})

// 					}

// 				});

// 			}

// 			handleSuccess(){
// 				fetch('?section_id=helper-cart')
// 					.then(response => response.text())
// 					.then(text => {
// 						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
// 						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
// 						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
// 						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
// 						this.cartDiscountError.innerHTML = '';
// 						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
// 							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
// 							this.discountCodes.classList.remove(`${this._prefix}processing`);
// 							this.loadDiscountButtons();
// 						}
// 						this.input.value = '';
// 					})
// 			}

// 			loadDiscountButtons(){
// 				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
// 					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
// 						elm.classList.add(`${this._prefix}enabled`);
// 						elm.addEventListener('click', (e)=>{
// 							e.preventDefault();
// 							this.cartSubtotal.classList.add(`${this._prefix}processing`);
// 							if (this.discountCodes) {
// 								this.discountCodes.classList.add(`${this._prefix}processing`);
// 							}
// 							const discountToRemove = elm.dataset.jsDiscount;
							
// 							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
// 							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
// 							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
// 							const body = JSON.stringify({ 
// 								discount: remainingDiscounts.join(',') 
// 							});
							
// 							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
// 								method: 'POST',
// 								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
// 								body 
// 							})
// 								.then(() => {
// 									this.handleSuccess();
// 								})
// 								.catch(error => {
// 									console.error(`Error: ${error}`);
// 								});
// 						});
// 					}
// 				});
// 			}
			
// 			handleError(){
// 				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
// 				if (this.discountCodes) {
// 					this.discountCodes.classList.remove(`${this._prefix}processing`);
// 				}
// 				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
// 			}

// 		}	
// 	)
// }




if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);
					//location.reload();
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						if (this.discountCodes) {
							this.discountCodes.classList.add('processing');
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							if (this.discountCodes) {
								this.discountCodes.classList.add('processing');
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				if (this.discountCodes) {
					this.discountCodes.classList.remove('processing');
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}


// Upsell cart script


(function(){
  const DEBUG = false;
  const upsellSectionSelector = '.cart_upsell_product';
  const gridSelector = '.grid'; 
  const KNOWN_HANDLES = ['tree-shrub-mitogrow','neem-oil']; 

  let templateMap = new Map();
  let inited = false;
  function log(...args){ if (DEBUG) console.log('[UPSELL]', ...args); }

  function extractHandle(el){
    if (!el) return null;
    if (el.dataset && el.dataset.productHandle) return el.dataset.productHandle;
    const attrEl = el.querySelector('[data-product-handle],[data-handle],[data-handle-js]');
    if (attrEl) return attrEl.dataset.productHandle||attrEl.dataset.handle||attrEl.dataset.handleJs;
    const a = el.querySelector('a[href*="/products/"]') || (el.tagName === 'A' ? el : null);
    if (a) {
      const href = a.getAttribute('href') || a.href || '';
      const m = href.match(/\/products\/([^\/?#/]+)/);
      if (m) return decodeURIComponent(m[1]);
    }
    return null;
  }

  async function fetchUpsellHtml(handle){
    try {
      const res = await fetch(`/?section_id=helper-cart-upsell&product_handle=${encodeURIComponent(handle)}`, {credentials:'same-origin'});
      if (!res.ok) return null;
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const found = doc.querySelector(`[data-product-handle="${handle}"]`) || doc.body.firstElementChild;
      return found ? found.cloneNode(true) : null;
    } catch (e) {
      log('fetchUpsellHtml error', e);
      return null;
    }
  }

  async function buildTemplates(){
    const upsell = document.querySelector(upsellSectionSelector);
    if (!upsell) return;
    const grid = upsell.querySelector(gridSelector) || upsell;


    const cards = Array.from(grid.querySelectorAll('[data-product-handle]'));
    for (const card of cards) {
      const h = extractHandle(card);
      if (h) {
        templateMap.set(h, card.cloneNode(true));
        log('saved template from DOM', h);
      }
    }

    for (const a of Array.from(grid.querySelectorAll('a[href*="/products/"]'))) {
      const parent = a.closest('[data-product-handle]') || a.closest('div');
      const h = extractHandle(parent || a);
      if (h && !templateMap.has(h)) {
        templateMap.set(h, (parent||a).cloneNode(true));
        log('saved template from anchor', h);
      }
    }

    for (const handle of KNOWN_HANDLES) {
      if (!templateMap.has(handle)) {
        const fetched = await fetchUpsellHtml(handle);
        if (fetched) {
          templateMap.set(handle, fetched);
          log('saved template from helper section (fetched)', handle);
        }
      }
    }
  }

  async function getCartHandles(){
    try {
      const res = await fetch('/cart.js', {credentials:'same-origin'});
      if (!res.ok) return [];
      const cart = await res.json();
      return cart.items.map(i => i.handle);
    } catch (e) {
      log('getCartHandles error', e);
      return [];
    }
  }

  async function updateUpsell(){
    try {
      const upsell = document.querySelector(upsellSectionSelector);
      if (!upsell) return;
      const grid = upsell.querySelector(gridSelector) || upsell;
      const cartHandles = await getCartHandles();

      const existing = Array.from(grid.querySelectorAll('[data-product-handle], a[href*="/products/"], .product-card'))
        .map(el => el.closest('[data-product-handle]') || el.closest('div'))
        .filter(Boolean);
      existing.forEach(card => {
        const h = extractHandle(card);
        if (h && cartHandles.includes(h)) {
          log('removing card (in cart)', h);
          card.remove();
        }
      });

      for (const [handle, template] of templateMap.entries()) {
        if (!cartHandles.includes(handle)) {
          const present = grid.querySelector(`[data-product-handle="${handle}"]`) ||
            Array.from(grid.querySelectorAll('a[href*="/products/"]')).map(a=>a.closest('[data-product-handle]')||a.closest('div')).find(el=>extractHandle(el)===handle);
          if (!present) {
            const clone = template.cloneNode(true);
            if (!clone.dataset.productHandle) clone.setAttribute('data-product-handle', handle);
            grid.appendChild(clone);
            log('reinserted template', handle);
          }
        }
      }

      const hasCard = !!grid.querySelector('[data-product-handle], a[href*="/products/"], .product-card');
      upsell.style.display = hasCard ? '' : 'none';
    } catch (e) {
      log('updateUpsell error', e);
    }
  }

  function attachListeners(){
    function attachToAjaxCart(){
      const ajax = document.getElementById('AjaxCartForm');
      if (ajax && !ajax._upsellAttached) {
        ajax.addEventListener('cart-updated', ()=> setTimeout(updateUpsell, 120));
        ajax._upsellAttached = true;
        log('attached to #AjaxCartForm');
      }
    }
    attachToAjaxCart();

    const mo = new MutationObserver(muts=>{
      attachToAjaxCart();
      muts.forEach(m => { if (m.target && m.target.id === 'AjaxCartForm') setTimeout(updateUpsell, 80); });
    });
    mo.observe(document.body, {childList:true, subtree:true});

    ['cart-updated','cart:updated','cart:update','cart_update'].forEach(ev => document.addEventListener(ev, ()=> setTimeout(updateUpsell, 120)));
    document.addEventListener('click', function(e){
      const upsell = e.target.closest(upsellSectionSelector);
      if (!upsell) return;
      setTimeout(updateUpsell, 600);
    }, true);
  }

  async function init(){
    if (inited) return;
    inited = true;
    await buildTemplates();
    attachListeners();
    setTimeout(updateUpsell, 200);
    log('upsell-initialized', Array.from(templateMap.keys()));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.UPSellUpdater = { init, updateUpsell, templateMap };

})();

